module.exports = __webpack_public_path__ + "static/dataset-0c867b9926b93356ec360c78bdf25799.png";